import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import img1 from "../../assets/pexels-max-fischer-5212320.jpg";
import img2 from "../../assets/pexels-max-fischer-5212345.jpg";
import img3 from "../../assets/pexels-tara-winstead-8386713.jpg";

import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const HomeSlider = () => {
  // Reference for Swiper instance
  const swiperRef = useRef(null);

  return (
    <div className="flat-slider container-fuild">
      <div className="row">
        <div className="widget-social-header">
          <div className="container-fluid">
            <ul className="widget-social-footer-item text-center">
              <li>
                <a href="#">
                  <i className="fa-brands fa-facebook"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i className="fa-brands fa-linkedin"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i className="fa-brands fa-instagram"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i className="fa-brands fa-youtube"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mark-slide">
          <img src="assets/images/mark-page/mark-icon-slide.png" alt="images" />
        </div>
        <div className="swiper-container mainslider">
          <Swiper
            className="swiper-wrapper"
            loop={true}
            speed={1000}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay, Navigation]}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
          >
            <SwiperSlide
              className="swiper-slide slider-st-1"
              style={{ backgroundImage: `url(${img1})` }}
            >
              <div className="content-slider-left text-white">
                <h3 className="sub-title-slider section-24px-montserrat">
                  I’m Olux Raymond,
                </h3>
                <h2 className="title-slider section-65px-montserrat">
                  A freelance
                  <br />
                  Interaction & Visual
                </h2>
                <p className="desc-slider">
                  Fusce tempor magna mi, non egestas velit ultricies nec. Aenean
                  convallis, risus non
                </p>
                <div className="button-slider">
                  <a
                    href="contact.html"
                    className="button-footer arrow-btn btn-st style-2"
                  >
                    Hire Me Now
                  </a>
                  <a
                    href="#"
                    className="button-footer clound-down btn-st border-white"
                  >
                    Download CV
                  </a>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide
              className="swiper-slide slider-st-1"
              style={{ backgroundImage: `url(${img2})` }}
            >
              <div className="content-slider-left text-white">
                <h3 className="sub-title-slider section-24px-montserrat">
                  I’m Olux Raymond,
                </h3>
                <h2 className="title-slider section-65px-montserrat">
                  A freelance
                  <br />
                  Interaction & Visual
                </h2>
                <p className="desc-slider">
                  Fusce tempor magna mi, non egestas velit ultricies nec. Aenean
                  convallis, risus non
                </p>
                <div className="button-slider">
                  <a
                    href="contact.html"
                    className="button-footer arrow-btn btn-st style-2"
                  >
                    Hire Me Now
                  </a>
                  <a
                    href="#"
                    className="button-footer clound-down btn-st border-white"
                  >
                    Download CV
                  </a>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide
              className="swiper-slide slider-st-1"
              style={{ backgroundImage: `url(${img3})` }}
            >
              <div className="content-slider-left text-white">
                <h3 className="sub-title-slider section-24px-montserrat">
                  I’m Olux Raymond,
                </h3>
                <h2 className="title-slider section-65px-montserrat">
                  A freelance
                  <br />
                  Interaction & Visual
                </h2>
                <p className="desc-slider">
                  Fusce tempor magna mi, non egestas velit ultricies nec. Aenean
                  convallis, risus non
                </p>
                <div className="button-slider">
                  <a
                    href="contact.html"
                    className="button-footer arrow-btn btn-st style-2"
                  >
                    Hire Me Now
                  </a>
                  <a
                    href="#"
                    className="button-footer clound-down btn-st border-white"
                  >
                    Download CV
                  </a>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
        <div className="main-slide-button">
          <button
            className="clone-main-btn-prev"
            onClick={() => swiperRef.current?.slidePrev()}
          ></button>
          <button
            className="clone-main-btn-next"
            onClick={() => swiperRef.current?.slideNext()}
          ></button>
        </div>
      </div>
    </div>
  );
};

export default HomeSlider;
